import {Component, EventEmitter, Input, Output } from '@angular/core';
import { environment } from '../../../../src/environments/environment'
import { publicHelpers } from 'globals/helpers/public-helpers';
import { EntityRequest } from 'globals/store/programs.data';
import { ShareWrapper } from './share-wrapper.component';
import { CommonModule } from '@angular/common';
import { MutatingInputComponent } from 'src/app/components/joi-input/mutating-input.component';
import { MatButtonModule } from '@angular/material/button';

@Component({
    selector: 'share-request',
    template: ` 
<div class="share-staging-request">
  <div *ngIf="loading" class="loading">Loading...</div>
  <div *ngIf="!loading && !eventTitle"  class="sorry" [innerHTML]="helpers.strWithBreak(inactiveMessage)"></div>
  <div *ngIf="submitted"  class="thanks" [innerHTML]="helpers.strWithBreak(resultMessage)"></div>
  <div class="container" *ngIf="eventTitle && !submitted">
    <h1>{{ eventTitle }}</h1>
    <h4>{{ (type === 'staging' ? '' : 'Stand: ') + addeeTitle }}</h4>
    <div *ngIf="adderName" class="performer_name">
    {{ type === 'staging' ? 'Performer' : 'Exhibitor' }}: {{ adderName }}
    </div>
    <div class="instructions">
    Please submit any {{ type }} requests for the above {{ type === 'staging' ? 'session' : 'stand' }}.
    </div>
    <div>
      <mutating-input
        [object]="request"
        [prop]="'requestText'"
        [isArea]="true"
        [areaMinRows]="5"
        [placeholder]="(type | titlecase) + ' request'"
        (textChange)="checkValidity()"
        ></mutating-input>
    </div>
    
    <div class="note">
      Note: This form will be deactivated after you submit. Please ensure you have included all your {{ type }} requests above before you submit.
    </div>

    <mutating-input 
      *ngIf="!adderName" 
      [object]="submitterForAnyone" 
      prop="name" 
      placeholder="Your name"
      (textChange)="checkValidity()"
    ></mutating-input>
    <button mat-button color="primary" (click)="submit.emit(request)" [disabled]="processing || disabled" >
      <div class="button_content">
        Submit
      </div>
    </button>
    <div class="error-holder" *ngIf="error" [innerHTML]="helpers.strWithBreak(error)"></div>
  </div>
</div>
    `,
    styleUrls: ['./share.editPerformer.scss'],
    standalone: true,
    imports: [CommonModule, MatButtonModule, MutatingInputComponent]
})
export class ShareRequestComponent extends ShareWrapper<ShareRequestComponent> {

    readonly api = `${environment.functionsURL}api/v1`; // NOTE this is pointing to api/v1 not api/app
    @Input() eventTitle: string
    @Input() addeeTitle: string
    @Input() adderName: string
    @Input() type: 'staging' | 'exhibitor' = 'staging'
    @Output() submit: EventEmitter<EntityRequest> = new EventEmitter()

    @Input() loading:boolean;
    @Input() processing:boolean;
    @Input() submitted:boolean;
    @Input() request: EntityRequest

    disabled: boolean = true
    submitterForAnyone = { name: '' }
    helpers = publicHelpers
    resultMessage = "Thank you"
    cannotSubmitMessage = "The requests can't be submitted at this time.\n\nPlease reload this page and try again."

    get inactiveMessage() {
      return `The ${this.type} request submission area is currently not available.\n\nPlease contact the event organiser.`
    }

    checkValidity(invalid = false) {
      this.disabled = !this.request.requestText|| (!this.adderName && !this.submitterForAnyone.name)
    }

}

